var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryBackwardOutline1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C10.7743 26 7.74871 24.72 5.51333 22.4839C5.12287 22.0933 5.12297 21.4601 5.51356 21.0697C5.90415 20.6792 6.53731 20.6793 6.92777 21.0699C8.79178 22.9345 11.3103 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C11.2614 4 8.71026 5.10803 6.85728 7.00037L8.5 7C9.05228 7 9.5 7.44772 9.5 8C9.5 8.51284 9.11396 8.93551 8.61662 8.99327L8.5 9H4.5C3.98716 9 3.56449 8.61396 3.50673 8.11662L3.5 8V4C3.5 3.44772 3.94772 3 4.5 3C5.01284 3 5.43551 3.38604 5.49327 3.88338L5.5 4L5.49973 5.52875C7.71675 3.30257 10.7495 2 14 2ZM14 8C14.5128 8 14.9355 8.38604 14.9933 8.88338L15 9V13.5858L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3466 18.0676 16.7794 18.0953 16.3871 17.7903L16.2929 17.7071L13.2929 14.7071C13.1366 14.5508 13.0374 14.3481 13.0087 14.1314L13 14V9C13 8.44772 13.4477 8 14 8Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryBackwardOutline1);
export default __webpack_public_path__ + "static/media/history_backward_outline-1.b9e005bcecd6a068615131f668a57b51.svg";
export { ForwardRef as ReactComponent };